import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';

import type { MatrixModelNode as IMatrixModelNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';


function MatrixModelNode(props: WorkflowNodeProps<IMatrixModelNode>) {
  const { id, type, data: { label } } = props;

  return (
    <BaseNode
      icon={
        <Icon icon={IconName.Matrix} size="large" />
      }
      id={id}
      label={label}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-juicyBlue-100)',
        hovered: {
          backgroundColor: 'var(--cl-juicyBlue-300)',
        },
        highlighted: {
          backgroundColor: 'var(--cl-juicyBlue-300)',
        },
      }}
      type={type}
    />
  );
}

export default React.memo(MatrixModelNode);
